import {setChatStorageItem} from './chatStorage';

const LEGACY_KEY = 'matrix-device-id';
const SCOPED_KEY_PREFIX = `${LEGACY_KEY}:`;

function buildScopedKey(tenant?: string | null, userId?: string | null): string | null {
    if (!tenant || !userId) return null;
    return `matrix-device-id:${tenant}_${userId}`;
}

function hasAnyScopedDeviceId(): boolean {
    for (let index = 0; index < localStorage.length; index += 1) {
        if (localStorage.key(index)?.startsWith(SCOPED_KEY_PREFIX)) {
            return true;
        }
    }

    return false;
}

export function getStoredDeviceId(tenant?: string | null, userId?: string | null): string | null {
    const scopedKey = buildScopedKey(tenant, userId);
    const scopedDeviceId = scopedKey ? localStorage.getItem(scopedKey) : null;

    if (scopedDeviceId) {
        return scopedDeviceId;
    }

    // A legacy ID is safe to adopt only when this browser has no scoped Matrix
    // devices at all. Once any account has a scoped ID, the global value cannot
    // be attributed to another account and must never be copied into its scope.
    const legacyDeviceId = localStorage.getItem(LEGACY_KEY);
    if (legacyDeviceId && scopedKey && !hasAnyScopedDeviceId()) {
        localStorage.setItem(scopedKey, legacyDeviceId);
        return legacyDeviceId;
    }

    return null;
}

export function persistDeviceId(deviceId: string, tenant?: string | null, userId?: string | null): void {
    const scopedKey = buildScopedKey(tenant, userId);
    if (scopedKey) {
        setChatStorageItem(scopedKey, deviceId);
    }
}

export function removeDeviceId(tenant?: string | null, userId?: string | null): void {
    const scopedKey = buildScopedKey(tenant, userId);
    if (scopedKey) {
        localStorage.removeItem(scopedKey);
    }
}
